import moment from "moment"

export const getComplexStartDate = complex => {
  const value = complex?.FechaInicio || complex?.FechaCreacion
  if (!value) return null
  const date =
    value.toDate?.() ||
    (typeof value.seconds === "number" ? new Date(value.seconds * 1000) : value)
  return moment(date).isValid() ? moment(date).toDate() : null
}
export const formatComplexStartDate = complex => {
  const date = getComplexStartDate(complex)
  return date ? moment(date).format("DD/MM/YYYY") : "Sin registrar"
}
export const calculateUnitBilling = (units, price) => {
  if (
    units === null ||
    units === undefined ||
    price === "" ||
    price === null ||
    price === undefined
  )
    return null
  const count = Number(units)
  const unitPrice = Number(price)
  if (
    !Number.isInteger(count) ||
    count < 0 ||
    !Number.isFinite(unitPrice) ||
    unitPrice < 0
  )
    return null
  return (count * Math.round(unitPrice * 100)) / 100
}

export const complexCommercialFields = values => {
  const value = values.ValorCobrar
  const amount =
    value === "" || value === null || value === undefined ? null : Number(value)
  if (
    amount !== null &&
    (!Number.isFinite(amount) ||
      amount < 0 ||
      Math.abs(amount * 100 - Math.round(amount * 100)) > 0.000001)
  )
    throw new Error(
      "El valor a cobrar debe ser positivo y tener hasta dos decimales"
    )
  const initialUnits =
    values.UnidadesHabitacionalesInicio === "" ||
    values.UnidadesHabitacionalesInicio == null
      ? null
      : Number(values.UnidadesHabitacionalesInicio)
  const unitPrice =
    values.ValorPorUnidad === "" || values.ValorPorUnidad == null
      ? null
      : Number(values.ValorPorUnidad)
  if (
    initialUnits !== null &&
    (!Number.isInteger(initialUnits) || initialUnits < 0)
  )
    throw new Error("Revisa las unidades habitacionales al inicio")
  if (
    unitPrice !== null &&
    (!Number.isFinite(unitPrice) ||
      unitPrice < 0 ||
      Math.abs(unitPrice * 100 - Math.round(unitPrice * 100)) > 0.000001)
  )
    throw new Error("Revisa el valor por unidad")
  const advisor = String(values.AsesorResponsable || "").trim()
  if (advisor.length > 100)
    throw new Error("El nombre del asesor admite hasta 100 caracteres")
  const date = getComplexStartDate({ FechaInicio: values.FechaInicio })
  if (values.FechaInicio && !date) throw new Error("Revisa la fecha de inicio")
  const closingDate = getComplexStartDate({ FechaInicio: values.FechaCierre })
  if (values.isActive === false && !closingDate)
    throw new Error("Registra la fecha de cierre para un conjunto inactivo")
  if (values.FechaCierre && !closingDate)
    throw new Error("Revisa la fecha de cierre")
  if (date && closingDate && moment(closingDate).isBefore(date, "day"))
    throw new Error("La fecha de cierre no puede ser anterior al inicio")
  return {
    AsesorResponsable: advisor,
    UnidadesHabitacionalesInicio: initialUnits,
    ValorPorUnidad: unitPrice,
    FechaInicio: date,
    ValorCobrar: amount,
    FechaCierre: closingDate,
    ServicioAdministracion: Boolean(values.ServicioAdministracion),
    ServicioSeguridad: Boolean(values.ServicioSeguridad),
    isActive: values.isActive !== false,
  }
}
